import IndustryFilter from './IndustryFilter.component';

export default IndustryFilter;